export default __webpack_public_path__ + "static/media/i-box.15e6a4ae.svg";